import config from "./config";
import util from "./util";
const route = {
  change(type, param) {
    let url = type;
    if (typeof param != "string") {
      param = "";
    }
    if (type == "infoCenter") {
      url = config.www + "/news.html";
    } else if (type == "newsInfo") {
      url = config.www + "/newsInfo.html";
    } else if (type == "openAccount") {
      url = config.realAccount;
    } else if (type == "demoAccount") {
      url = config.myid + "/cn/demoAccount.html?action=0";
    } else if (type == "userCenter") {
      url = config.userCenter;
    } else if (type == "download") {
      url = "downloadCenter";
    } else if (type == "app") {
      url = config.app;
    } else if (type == "quote") {
      url = config.goquote;
    } else if (type == "gts2hangqing") {
      url = config.gts2hangqing;
    } else if (type == "contractRule") {
      url = `${config.www}/contract/rule.html`;
    } else if (type == "google") {
      url = config.googlePlay;
    }
    const wwwPages = ["nonfarm", "fedrate", "oil", "gold", "opec", "pce", "cpi", "pmi", "gdp", "retail", "fundamentals", "beginner", "macd", "kd"];
    if (wwwPages.includes(type)) {
      url = `${config.www}/${type}.html`;
    }
    url = `${url}${param}`;
    if (url) {
      url = url.trim();
      if (type == "openAccount") {
        url = `${url}?utm_source=${util.getCookie("utm_source")}&utm_medium=${util.getCookie("utm_medium")}`;
      }
      if (url.startsWith("http")) {
        window.open(url, "_blank");
      } else {
        const isFromApp = util.isFromApp();
        if (type == "customerService") {
          if (isFromApp) {
            window.open(`/${url}`, "_blank");
          } else {
            window.location.href = `/${url}`;
          }
        } else {
          if (isFromApp) {
            window.open(`./${url}`, "_blank");
          } else {
            window.location.href = `./${url}`;
          }
        }
      }
    }
  },
};
export default route;
